
/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Swal from "sweetalert2";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// NewEvent page components
import FormFields from "./components/FormFields";
import { addNewMediaImgsApi } from "api/medias";
import  {addNewCouponApi}  from "api/coupons";


import { useNavigate } from "react-router-dom";

function NewCoupon() {
  const navigate = useNavigate();

  const [formValue, setFormValue] = useState({});

  // useEffect(() => {
  //   console.log("formValue changed:", formValue);
  // }, [formValue]);

  const handleAddNewEvent = async () => {
    try {
      const updatedSiege = formValue?.siege?.map(siegeItem => ({
        ...siegeItem,
        restNumberOfUse: siegeItem.numberOfUse, 
      })) || "";
  
      const coponObject = {
        eventId: formValue?.eventId || "",
        coponCode: formValue?.coponCode || "",
        reduction: formValue?.reduction || "",
        fromDate: formValue.fromDate || null,
        toDate: formValue.toDate || null,
        typeOfCopon: formValue.typeOfCopon || null,
        siege: updatedSiege 
      };
  
      console.log("Sending coupon data:", coponObject);
  
      const result = await addNewCouponApi(coponObject);
  
      Swal.fire({
        title: "Ajoutée",
        text: result.message,
        icon: "success"
      });
  
      navigate("/coupons/voir");
    } catch (err) {
      const errorMessage = err?.response?.data?.error || "Une erreur s'est produite";
  
      Swal.fire({
        title: errorMessage,
        text: "",
        icon: "error"
      });
    }
  };

  const handleGetFormValues = (value) => {
    try {
        setFormValue(prevState => ({
            ...prevState,
            siege: value.siege, 
            ...value
        }));
    } catch (err) {
        console.log(err);
    }
};

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Ajouter un coupon
              </MDTypography>
              <MDBox mt={1} mb={2}>
                <MDTypography variant="body2" color="text"></MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton variant="gradient" color="info" onClick={handleAddNewEvent}>
                  Ajouter
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormFields formValues={handleGetFormValues} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewCoupon;
